import script from "./EditableNode.vue?vue&type=script&lang=ts&setup=true"
export * from "./EditableNode.vue?vue&type=script&lang=ts&setup=true"

import "./EditableNode.vue?vue&type=style&index=0&id=3c7c2fc2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c7c2fc2"]])

export default __exports__